module.exports = __webpack_public_path__ + "img/analyse-black@2x.928a0725.png";